module.exports = __webpack_public_path__ + "img/engagement.b336cfd.jpg";